module.exports = ".panel .table {\n  margin-bottom: -1px; }\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/observations/pages/observations/edit/edit.component.scss
// module id = ./apps/eyewatch/src/app/eyewatch/observations/pages/observations/edit/edit.component.scss
// module chunks = main